import type { Job } from "../../api/generated/model";
import { outputMedium } from "../../platform/jobs/detail/outputs";
import { GenerationLoader } from "../../ui/GenerationLoader";
import { SoundWave } from "../../ui/SoundWave";
import classes from "./running.module.css";

/**
 * A running job's picture in Pro: live's loader on a generation in progress (`GenerationLoader`,
 * the dots that gather into the Created.ai mark) for an image, a video or a talking head, or a
 * sound's waveform, moving, as the Sounds page's running sound (spec
 * ui-perf/ui-switch-classic-simple-pro, PR e9, decision 18). A video's dots sit on live's blurred
 * placeholder (decision 20). The result replaces it.
 */
export function RunningMedia({ job }: { job: Job }) {
  const sound = job.type.startsWith("audio.");
  return (
    <div className={classes.running} data-running>
      {sound ? (
        <SoundWave className={classes.wave} animated />
      ) : (
        <GenerationLoader label="Being made" video={outputMedium(job) === "video"} />
      )}
    </div>
  );
}
